import { Preset } from "@/models/configurator/configurator_options";
import { Collection } from "@/models/products/collection";
import { StockState } from "./types";

export const setStock = (state: StockState, value: boolean) => {
  state.stock = value;
};

